<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">解绑FRM</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			取消本机与当前所绑定项目/人员组的绑定关系，解绑后，本地同步的人员数据将会删除。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceUnBindFRM(UnBindFRMCallbackInterface UnBindFRMCallback)
//解绑FRM回调接口
public interface UnBindFRMCallbackInterface {
    void UnBindFRMCallback(int Code, String Msg);
}</code></pre>
		<h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">
             <p class="doc_main_p">UnBindFRMCallback：解绑FRM的结果回调接口</p>
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">UnBindFRMCallback(int Code, String Msg)：Code错误码，0为成功，其他失败；Msg：错误消息</p>
        <h3 class="doc_main_h3">错误码列表</h3>
		<get-frm-bind-code-error-list :propsTableData="errorCodeList"></get-frm-bind-code-error-list>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceUnBindFRM(new UnBindFRMCallbackInterface() {
    @Override
    public void UnBindFRMCallback(int Code, String Msg) {
        //TODO 在这里接收解绑FRM的结果信息
    }
});</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import GetFRMBindCodeErrorList from '../../../../components/getFRMBindCodeErrorList';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'get-frm-bind-code-error-list':GetFRMBindCodeErrorList,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','视频接口','解绑FRM'],
				errorCodeList:[
					{"code":"0","msg":"成功"},
					{"code":"10004","msg":"终端未绑定项目"},
					{"code":"-500","msg":"网络请求失败"},
				]
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	


// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/voideinitiali/voideuntyingfrm.vue